import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { useEffect, useState } from "react";
import { GameStatus } from "redux-store/slices/game/game.interfaces";

export const useBoard = () => {
  const dispatch = useDispatch();

  const chosenLevel = useSelector(selectors.getChosenLevel);
  const status = useSelector(selectors.getGameStatus);

  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    dispatch(actions.setGameStatus(GameStatus.COUNTDOWN));

    return () => {
      dispatch(actions.resetGame());
    };
  }, [dispatch]);

  // Countdown timer logic
  useEffect(() => {
    let intervalRef;

    if (status === GameStatus.COUNTDOWN && !intervalRef) {
      intervalRef = setInterval(() => {
        setCountdown((counter) => counter - 1);
      }, 1000);
    }

    if (countdown <= 0) {
      clearInterval(intervalRef);
    }

    return () => clearInterval(intervalRef);
  }, [status, countdown]);

  // Start game logic
  useEffect(() => {
    if (countdown <= 0) {
      // Evaluate random rotations
      const randomRotations = new Array(chosenLevel.tiles.length).fill(0);
      let correctTiles = chosenLevel.tiles.length;

      while (correctTiles > chosenLevel.maxCorrectStartingTiles) {
        for (let i = 0; i < randomRotations.length; i++) {
          randomRotations[i] = Math.floor(Math.random() * 4 + 4);
        }

        correctTiles = randomRotations.reduce(
          (correctTilesCount, current) =>
            current % 4 === 0 ? correctTilesCount + 1 : correctTilesCount,
          0,
        );
      }

      // Set randomized tiles and start game
      dispatch(
        actions.setRotations(
          randomRotations.map((turns) => ({ turns, canRotate: true })),
        ),
      );
      dispatch(actions.setGameStatus(GameStatus.PLAYING));
    }
  }, [chosenLevel, countdown, dispatch]);

  return { chosenLevel, countdown, status };
};
